/**
 * @(#)2020/03/03.
 * YxAction PackUpAction ，收起按钮
 * @author 足道
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */

/**
 * @param {object} packUpParam.mainParam 收起参数,主按钮的参数
 * @param {object} packUpParam.mainStyle 收起参数,收起主样式类型，与action的styleType对应
 * @param {object} packUpParam.overlayParam 收起参数,收起的跟元素参数
 * @export
 * @returns
 */
export default function () {
  return {
    packUpParam: {
      mainParam: {}, // 收起时，主按钮的配置
      mainStyle: "link", // 收起时，展示样式
      overlayParam: {}, // 主参数
    },
  };
}



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxAction/PackUpAction/param.js